import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrich.canvas.thumbnails');
import { OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-portal-nrich-canvas-thumbnails',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichCanvasThumbnailsComponent implements OnInit, OnChanges {
    @Input() documentId: string = '';
    @Input() pdfName: string = '';
    @Input() pages: any[] = [];
    @Input() currentPage: number = 1;
    @Output() pageSelect = new EventEmitter<number>();

    @ViewChild('thumbStrip') thumbStripRef!: ElementRef<HTMLDivElement>;

    public kgPages: Set<number> = new Set();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.documentId) {
            await this.loadKgPages();
        }
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (changes['documentId'] && this.documentId) {
            await this.loadKgPages();
        }
        // 현재 페이지 변경 시 썸네일 스크롤
        if (changes['currentPage'] && this.thumbStripRef?.nativeElement) {
            this.scrollToActive();
        }
    }

    private async loadKgPages() {
        try {
            const { code, data } = await wiz.call('kg_pages', {
                document_id: this.documentId,
            });
            if (code === 200) {
                this.kgPages = new Set(data.pages || []);
                await this.service.render();
            }
        } catch { /* ignore */ }
    }

    public selectPage(page: number) {
        this.pageSelect.emit(page);
    }

    public scrollLeft() {
        if (this.thumbStripRef?.nativeElement) {
            this.thumbStripRef.nativeElement.scrollLeft -= 200;
        }
    }

    public scrollRight() {
        if (this.thumbStripRef?.nativeElement) {
            this.thumbStripRef.nativeElement.scrollLeft += 200;
        }
    }

    public hasKg(page: number): boolean {
        return this.kgPages.has(page);
    }

    public hasImages(pageData: any): boolean {
        return (pageData.image_count || pageData.object_count || 0) > 0;
    }

    private scrollToActive() {
        setTimeout(() => {
            const strip = this.thumbStripRef?.nativeElement;
            if (!strip) return;
            const active = strip.querySelector('.thumb-active') as HTMLElement;
            if (active) {
                active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
        }, 50);
    }
}

export default PortalNrichCanvasThumbnailsComponent;